import { render, staticRenderFns } from "./OnboardingCompanyRentalCarsExtraCosts.vue?vue&type=template&id=3b50a070"
import script from "./OnboardingCompanyRentalCarsExtraCosts.vue?vue&type=script&lang=js"
export * from "./OnboardingCompanyRentalCarsExtraCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports